import { useDataSubmit } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let submit = useDataSubmit({
    context: 'check_in',
    viewPath: props.viewPath,
  })

  return async function onClick() {
    submit({ type: 'confirm_check_in' })

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
